import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Search from './search/Search';
import Analysis from './analysis/Analysis';
import { compose } from 'redux';
import { connect } from 'react-redux';

class SiteSeeker extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired
    };

    constructor (props) {
        super(props);
    }

    render () {
        const { classes } =this.props;

        const tab = this.props.analysis !== null;

        return (
            <div className={classes.root}>
                {!tab && <Search />}
                {tab && <Analysis />}
            </div>
        );
    }
}

const style = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
    }
});

const mapStateToProps = state => {
    return {
        isAnalysing: state.analysis.isAnalysing,
        analysis: state.analysis.analysis
    };
};

const mapDispatchToProps = dispatch => ({

});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(SiteSeeker);